import _toConsumableArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import * as React from "react";
import { isDefined, makeUseContext } from "../utils.js";
var TimeoutsContext = React.createContext(null);
export var useTimeouts = makeUseContext("useTimeouts", "TimeoutsContext", TimeoutsContext);
export var TimeoutsProvider = function TimeoutsProvider(_ref) {
  var children = _ref.children;
  var timeouts = React.useRef([]);

  var removeTimeout = function removeTimeout(id) {
    var _timeouts$current;

    (_timeouts$current = timeouts.current).splice.apply(_timeouts$current, [0, timeouts.current.length].concat(_toConsumableArray(timeouts.current.filter(function (tid) {
      return tid !== id;
    }))));
  };

  var setTimeout = function setTimeout(func, time) {
    var id = window.setTimeout(function () {
      removeTimeout(id);
      func();
    }, time);
    timeouts.current.push(id);
    return id;
  };

  var clearTimeout = function clearTimeout(id) {
    if (isDefined(id)) {
      removeTimeout(id);
      window.clearTimeout(id);
    }
  };

  var clearTimeouts = function clearTimeouts() {
    timeouts.current.forEach(function (tid) {
      return window.clearTimeout(tid);
    });
    timeouts.current.splice(0, timeouts.current.length);
  };

  React.useEffect(function () {
    return function () {
      return clearTimeouts();
    };
  }, []);
  var context = React.useRef({
    setTimeout: setTimeout,
    clearTimeout: clearTimeout,
    clearTimeouts: clearTimeouts
  });
  return React.createElement(TimeoutsContext.Provider, {
    value: context.current
  }, children);
};